export class CategoryDTO{
    // id!:number;
    // image:any;
    // name:string = '';
    // status !: any
    // ingredientsCount :number = 0


    name:string = ''
    image:any
    status:any
    id !:number 
    categoryStatus !: boolean
}


export class LinkedCategoryIngredientsDTO{
    id !: number;
    image : any;
    name: string = ''
    status : any
    associationId !: number
}

export class categoriesSearchDTO {
    categoryName :string ='';
    status : string = '--';
    offset : number = 0;
    limit : number = 10;
}